import { ServiceGroup } from '@services';
import { useStore } from '@stores';
import { Form } from 'antd';
import React, { useCallback } from 'react';
import Presentation from './CreateServiceGroupForm.presentation';
interface IProps {
  submitTitle?: string;
  onCancel: (value: boolean) => void;
  handleSelect?: (id: number) => void;
}

export const CreateServiceGroupForm: React.FC<IProps> = ({
  submitTitle,
  onCancel,
  handleSelect,
}) => {
  const [form] = Form.useForm();
  const { serviceGroupStore } = useStore();

  const onFinish = useCallback(
    async (values: ServiceGroup) => {
      await serviceGroupStore.create({ ...values }).then((result) => {
        form.resetFields();
        onCancel(false);
        handleSelect && handleSelect(result.id);
      });
    },
    [form, serviceGroupStore, onCancel, handleSelect]
  );

  return (
    <Presentation form={form} submitTitle={submitTitle} onCancel={onCancel} onFinish={onFinish} />
  );
};
